import Vue from 'vue';
import _ from 'lodash';
import {
    GET_RECENT_INCOME_REQUEST,
    GET_RECENT_INCOME_SUCCESS,
    GET_RECENT_INCOME_FAILURE,
    GET_RECENT_PC_INCOME_REQUEST,
    GET_RECENT_PC_INCOME_SUCCESS,
    GET_RECENT_PC_INCOME_FAILURE,
    GET_RECENT_ORDER_COUNT_REQUEST,
    GET_RECENT_ORDER_COUNT_SUCCESS,
    GET_RECENT_ORDER_COUNT_FAILURE,
    GET_RECENT_CAR_INCOME_REQUEST,
    GET_RECENT_CAR_INCOME_SUCCESS,
    GET_RECENT_CAR_INCOME_FAILURE,
} from '../mutationTypes';

const state = {
    // 近期总收入
    incomeLoading: false,
    incomeTotal: {},

    // 近期收银系统收入
    pcIncomeLoading: false,
    pcIncomeTotal: {},

    // 近期订单统计
    orderRecentLoading: false,
    orderRecentStat: {},
    orderRecentCar: {},
    customerStat: {},
    list: {},

    // 接车订单支付占比
    carIncomeLoading: false,
    carIncomeTotal: {},
};

const mutations = {
    [GET_RECENT_INCOME_REQUEST](state) {
        state.incomeLoading = true;
    },
    [GET_RECENT_INCOME_SUCCESS](state, res) {
        state.incomeLoading = false;

        // state.incomeTotal = res;
        _.extend(state, {
            incomeTotal: res
        });
    },
    [GET_RECENT_INCOME_FAILURE](state) {
        state.incomeLoading = false;

        state.incomeTotal = null;
    },
    [GET_RECENT_PC_INCOME_REQUEST](state) {
        state.pcIncomeLoading = true;
    },
    [GET_RECENT_PC_INCOME_SUCCESS](state, res) {
        state.pcIncomeLoading = false;
        _.extend(state, {
            pcIncomeTotal: res
        });
    },
    [GET_RECENT_PC_INCOME_FAILURE](state) {
        state.pcIncomeLoading = false;
    },
    [GET_RECENT_ORDER_COUNT_REQUEST](state) {
        state.orderRecentLoading = true;
    },
    [GET_RECENT_ORDER_COUNT_SUCCESS](state, res) {
        state.orderRecentLoading = false;
        const chunkNum = Math.ceil(res.addUserStat.list.length / 2);
        const listData = _.chunk(res.addUserStat.list, chunkNum);
        _.extend(state, {
            orderRecentStat: res.orderStat,
            orderRecentCar: res.ordersCar,
            customerStat: res.addUserStat,
            list: listData
        });
    },
    [GET_RECENT_ORDER_COUNT_FAILURE](state) {
        state.orderRecentLoading = false;
    },
    [GET_RECENT_CAR_INCOME_REQUEST](state) {
        state.carIncomeLoading = true;
    },
    [GET_RECENT_CAR_INCOME_SUCCESS](state, res) {
        state.carIncomeLoading = false;
        _.extend(state, {
            carIncomeTotal: res
        });
    },
    [GET_RECENT_CAR_INCOME_FAILURE](state) {
        state.carIncomeLoading = false;
    },
};

export const actions = {
    async getStoreIncome({ commit }, type) {
        commit(GET_RECENT_INCOME_REQUEST);
        const res = await Vue.$ajax.post('income', {
            type,
        });

        if (!res.errorType) {
            commit(GET_RECENT_INCOME_SUCCESS, res);
        } else {
            commit(GET_RECENT_INCOME_FAILURE);
        }
    },
    async getPcIncome({ commit }, type) {
        commit(GET_RECENT_PC_INCOME_REQUEST);
        const res = await Vue.$ajax.post('pcIncome', {
            type
        });

        if (!res.errorType) {
            commit(GET_RECENT_PC_INCOME_SUCCESS, res);
        } else {
            commit(GET_RECENT_PC_INCOME_FAILURE);
        }
    },

    async getCarIncome({ commit }, type) {
        commit(GET_RECENT_CAR_INCOME_REQUEST);
        const res = await Vue.$ajax.post('paymentStatByPickcar', {
            type
        });

        if (!res.errorType) {
            commit(GET_RECENT_CAR_INCOME_SUCCESS, res);
        } else {
            commit(GET_RECENT_CAR_INCOME_FAILURE);
        }
    },

    async getOrderRecent({ commit }) {
        commit(GET_RECENT_ORDER_COUNT_REQUEST);
        const res = await Vue.$ajax.post('orderRecent');

        if (!res.errorType) {
            commit(GET_RECENT_ORDER_COUNT_SUCCESS, res);
        } else {
            commit(GET_RECENT_ORDER_COUNT_FAILURE);
        }
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/incomeOverview.js